import { Step, StepName } from '|/app/services';

export const VERIFICATION_STEP_IDS = new Set<StepName>([
  StepName.PlaceOrder,
  StepName.IdentityVerification,
  StepName.BAV,
  StepName.Income,
  StepName.Address,
  StepName.TradeVerification,
  StepName.AdditionalIncome
]);

/** Derives the URL set from live dashboard steps. Called wherever a Set<string> of verification URLs is needed. */
export function buildVerificationStepUrlSet(steps: Step[]): Set<string> {
  return new Set(steps.filter(s => VERIFICATION_STEP_IDS.has(s.id)).map(s => s.url));
}
